import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import i18n from '../../utils/i18n'
import { VolumeUnitBodyTemplate } from './VolumeUnitBodyTemplate'

export const VolumeUnitFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const units: any[] = ['M3']

  const valueTemplate = (option: any, props: any) => {
    if (option) {
      return VolumeUnitBodyTemplate(option)
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => VolumeUnitBodyTemplate(option)

  return (
    <Dropdown
      value={options.value}
      options={units}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.search')}
    />
  )
}
